import { render, staticRenderFns } from "./ProductAttributeSelectorConfirmation.vue?vue&type=template&id=cdf399b6&scoped=true&"
import script from "./ProductAttributeSelectorConfirmation.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeSelectorConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributeSelectorConfirmation.vue?vue&type=style&index=0&id=cdf399b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf399b6",
  null
  
)

export default component.exports